import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const PATIENT_PATH = "/patient/v1";

// Patient

export const getPatientApi = async (params, options = {}) => await getRequest(PATIENT_PATH, params, options);

export const getPatientByIdApi = async (params, options = {}) => await getRequest(`${PATIENT_PATH}/${params?.patientId}`);

export const addPatientApi = async (body) =>
  await postRequest(PATIENT_PATH, body);

export const updatePatientApi = async (body) =>
  await putRequest(`${PATIENT_PATH}/${body?._id}`, body);

export const deletePatientByIdApi = async (id) =>
  await deleteRequest(`${PATIENT_PATH}/${id}`);

export const uploadImageApi = async (body) =>
  await postRequest(`${PATIENT_PATH}/image`, body, true);
